document.addEventListener('DOMContentLoaded', function() {
  var botonesCerrarSubMenu = document.querySelectorAll('.thb-full-menu li.menu-item-has-children.menu-item-has-megamenu .sub-menu li #cerrar-menu');
  botonesCerrarSubMenu.forEach(function(boton) {
    boton.addEventListener('click', function(e) {
      e.stopPropagation(); // Evitar que el evento de clic se propague al elemento del submenu
      var submenu = this.closest('.sub-menu');
      if (submenu) {
        submenu.style.display = 'none';
      }
    });
  });

  var elementosMenuConSubmenu = document.querySelectorAll('.thb-full-menu li.menu-item-has-children.menu-item-has-megamenu');
  elementosMenuConSubmenu.forEach(function(elemento) {
    elemento.addEventListener('mouseover', function() {
      var submenu = this.querySelector('.sub-menu');
      if (submenu) {
        submenu.style.display = 'flex';
      }
    });

    elemento.addEventListener('mouseout', function() {
      var submenu = this.querySelector('.sub-menu');
      if (submenu) {
        submenu.style.display = 'none';
      }
    });
  });
});
